import CategoryPage from "@/pages/dashboard/category";
import ProductCategoriesPage from "@/pages/dashboard/product-categories";
import HomePage from "@/components/dashboard/HomePage";

import UsersPage from "@/pages/dashboard/user";
import AddStaff from "@/pages/dashboard/staff/addStaff";
import StaffPage from "@/pages/dashboard/staff";
import StaffRoles from "@/pages/dashboard/staff/staffRoles";

import NotificationsPage from "@/pages/dashboard/notification";
import AddNotification from "@/pages/dashboard/notification/addNotification";

import AddPost from "@/pages/dashboard/feed/addPost";

import AddProduct from "@/pages/dashboard/product/addProduct";
import ProductsPage from "@/pages/dashboard/product";
import AddDirectory from "@/pages/dashboard/dxn-directory/addDirectory";
import DirectoryPage from "@/pages/dashboard/dxn-directory";

import StaffPermission from "@/pages/dashboard/staff/staffPermission";
import Feed from "@/pages/dashboard/feed";
import GutWellnessFact from "@/pages/dashboard/gut-wellness";
import GutWellnessDailyChallenge from "@/pages/dashboard/gut-wellness/dailyChallenge";
import NutritionFacts from "@/pages/dashboard/nutrition";
import NutritionDailyChallenges from "@/pages/dashboard/nutrition/dailyChallenge";
import SleepExerciseFact from "@/pages/dashboard/sleep-exercise";
import SleepExerciseFactsTable from "@/pages/dashboard/sleep-exercise";
import DailyExerciseFactsTable from "@/pages/dashboard/sleep-exercise/dailyexercise";
import EmotionalWellnessFactsTable from "@/pages/dashboard/sleep-exercise/emotional-wellness";
import StressManagementFactsTable from "@/pages/dashboard/sleep-exercise/stress-management";

import {
  Archive,
  Bell,
  Book,
  Boxes,
  Home,
  Rss,
  UserMinus2,
  Users,
  BicepsFlexed,
  Apple,
  Salad,
  MessageSquare,
} from "lucide-react";
import AddExpert from "@/pages/dashboard/expert/addExpert";
import Expert from "@/pages/dashboard/expert";
import CreateMessagePage from "@/pages/dashboard/messages/CreateMessagePage";

const routes = [
  {
    id: "dashboard",
    label: "Dashboard",
    icon: <Home size={20} />,
    path: "",
    element: <HomePage />,
  },
  // {
  //   id: "category",
  //   label: "Feed Categories",
  //   icon: <Boxes size={20} />,
  //   path: "category",
  //   element: <CategoryPage />,
  // },
  // {
  //   id: "product-categories",
  //   label: "Product Categories",
  //   icon: <Boxes size={20} />,
  //   path: "product-categories",
  //   element: <ProductCategoriesPage />,
  // },
  {
    id: "gut-wellness",
    label: "Gut and Wellness",
    icon: <Salad size={20} />,
    path: "gut-wellness",
    children: [
      {
        id: "add fact",
        label: "Daily Wellness Fact",
        path: "add-fact",
        element: <GutWellnessFact />,
       },
      {
        id: "daily challenge",
        label: "Daily Challenge",
        path: "daily-challenge",
        element: <GutWellnessDailyChallenge />,
      },
    ],
  },
  {
    id: "nutrients",
    label: "Nutrients",
    icon: <Apple size={20} />,
    path: "nutrients",
    children: [
      {
        id: "add fact",
        label: "Daily Nutrient Fact",
        path: "add-fact",
        element: <NutritionFacts />,
       },
       {
        id: "daily challenge",
        label: "Daily Challenge",
        path: "daily-challenge",
        element: <NutritionDailyChallenges />,
      },
    ],
  },
  {
    id: "sleep-exercise",
    label: "Sleep and Exercise",
    icon: <BicepsFlexed size={20} />,
    path: "sleep-exercise",
    children: [
      {
        id: "sleep facts",
        label: "Daily Sleep Facts",
        path: "add-sleep-facts",
        element: <SleepExerciseFactsTable />,
      },
      {
        id: "daily exercise",
        label: "Daily Exercise",
        path: "add-exercise-facts",
        element: <DailyExerciseFactsTable />,
      },
      {
        id: "daily emotional wellness",
        label: "Daily Emotional Therapy",
        path: "daily-emotional-wellness",
        element: <EmotionalWellnessFactsTable />,
      },
      {
        id: "daily stress management",
        label: "Daily Stress Management",
        path: "daily-stress-management",
        element: <StressManagementFactsTable />,
      },
    ],
    element: <SleepExerciseFact />,
  },
  {
    id: "users",
    label: "Users",
    icon: <Users size={20} />,
    path: "users",
    children: [
      {
        id: "all users",
        label: "All Users",
        path: "all-users",
        element: <UsersPage />,
      },
    ],
  },
  {
    id: "experts",
    label: "Experts",
    icon: <UserMinus2 size={20} />,
    path: "experts",
    children: [
      {
        id: "add expert",
        label: "Add Expert",
        path: "add-expert",
        element: <AddExpert />,
      },
      {
        id: "all experts",
        label: "All Experts",
        path: "all-expert",
        element: <Expert />,
      },
    ],
  },
  {
    id: "notifications",
    label: "Notifications",
    icon: <Bell size={20} />,
    path: "notifications",
    children: [
      {
        id: "add notification",
        label: "Add Notification",
        path: "add-notification",
        element: <AddNotification />,
      },
      {
        id: "manage notification",
        label: "Manage Notifications",
        path: "manage-notification",
        element: <NotificationsPage />,
      },
    ],
  },
  {
    id: "products",
    label: "Products",
    icon: <Archive size={20} />,
    path: "products",
    children: [
      {
        id: "add product",
        label: "Add Product",
        path: "add-product",
        element: <AddProduct />,
      },
      {
        id: "manage product",
        label: "Manage Product",
        path: "manage-product",
        element: <ProductsPage />,
      },
      {
        id: "product-categories",
        label: "Product Categories",
        path: "product-categories",
        element: <ProductCategoriesPage />,
      },
    ],
  },
  {
    id: "feed",
    label: "Feed",
    icon: <Rss size={20} />,
    path: "feed",
    children: [
      {
        id: "add post",
        label: "Add Post",
        path: "add-post",
        element: <AddPost />,
      },
      {
        id: "manage post",
        label: "Manage Post",
        path: "manage-post",
        element: <Feed />,
      },
      {
        id: "category",
        label: "Feed Categories",
        path: "category",
        element: <CategoryPage />,
      },
    ],
  },
  {
    id: "dxn office directory",
    label: "DXN Office Directory",
    icon: <Book size={20} />,
    path: "dxn-office-directory",
    children: [
      {
        id: "add office directory",
        label: "Add Office Directory",
        path: "add-office-directory",
  element: <AddDirectory />,
      },
      {
        id: "manage office directory",
        label: "Manage Office Directory",
        path: "manage-office-directory",
  element: <DirectoryPage />,
      },
    ],
  },
  {
    id: "staff",
    label: "Staff",
    icon: <UserMinus2 size={20} />,
    path: "staff",
    children: [
      
      {
        id: "manage staff",
        label: "All Staff",
        path: "manage-staff",
        element: <StaffPage />,
      },
      { id: "staff roles", label: "Staff Roles", path: "staff-roles", element: <StaffRoles /> },
      {
        id: "staff permissions",
        label: "Staff Permissions",
        path: "staff-permission",
        element: <StaffPermission />,
      },
    ],
  },
  {
    id: "dxn-dashboard",
    label: "DXN Dashboard",
    icon: <MessageSquare size={20} />,
    path: "dxn-dashboard",
    children: [
      {
        id: "messages",
        label: "Messages",
        path: "messages",
        element: <CreateMessagePage />,
      },
    ],
  },
];


export default routes;
